
<div class="box_item" *ngIf="status==STATUS_DONE else loadingconditionsmain">
  <label class="box-label">RULE CONDITIONS</label>
  <p>These are the conditions when the rule applies. No conditions means it universally applies. Remember to check your OR / AND logic!</p>
  <!-- conditions control radio button here!!! -->
  <div [formGroup]="form" class="conditions-control">
      <core-helpers-forms-input-radio
          [name]="'conditionsControl'"
          [radioItems]="conditionsControlValues"
          [form]="form"
          [selectedValue]= "rule.conditions_control"
          (selectedChange)="onConditionsControlChange($event)"
      ></core-helpers-forms-input-radio>
  </div>

  <!-- empty rule for the buttons -->
  <!-- this is a item of conditions wiht 3 selectors and 2 buttons -->
  <div class="condition-item" *ngIf="conditionForms.length > 0">
    <!-- TODO oct-2023: rules conditions form item component with the conditions in the form, not in the rules. 
            we must avoid template reloads or reduce it at minimum posible.

             <p> RULE HAS CONDITIONS {{conditionForms.length}} </p> 
    -->

      <settings-rules-rule-conditions-item
        *ngFor="let conditionForm of conditionForms"
        [conditionForm]="conditionForm"
        [availableConditions]="currentEventConditions"
        [ruleConditions]="rule.conditions"
        (clickAdd)="addCondition()"
        (clickRemove)="removeCondition($event)"
        (changeRuleCondition)="onConditionChange($event)"
      ></settings-rules-rule-conditions-item>
  </div>
  <div class="condition-any" *ngIf="conditionForms && conditionForms.length == 0">
      <span>Any condition selected</span>
      <core-helpers-forms-button-icon [text]="'Add condition'" [icon]="'add'" (click)="addCondition()" ></core-helpers-forms-button-icon>
  </div>
</div>

 <ng-template #loadingconditionsmain> 
  <div class="loader">
    <div class="dimmed">
      <div class="dimmed_info"></div>
      <div class="dimmed_flex">
        <div class="dimmed_title"></div>
        <div class="dimmed_subtitle"></div>
      </div>
    </div>
  </div>
</ng-template> 
